import { toast } from 'sonner';
import { t } from '@/shared/i18n/t';
import { replica } from '@/shared/sync/replica';
import type { CollectionName } from './collection-name';
import { restoreRecord } from './restore-record';

/** Soft delete: the record goes to the trash; the toast offers to undo it straight away. */
export async function deleteRecord(collection: CollectionName, id: string): Promise<void> {
  await replica.mutate(collection, 'delete', {}, id);
  toast.success(t('Moved to the trash'), {
    action: { label: t('Undo'), onClick: () => void restoreRecord(collection, id) },
  });
}
